const ipAuthReducer = (state = { active: false }, action) => {
  switch (action.type) {
    case 'IP_AUTH_LOGIN':
      return { active: true };
    case 'LOGOUT':
    case 'LOGOUT_SUCCESS':
      return { active: false };
    default:
      return state;
  }
};

export default ipAuthReducer;
